import ProjectFilePlanReducerAction from "./project-file-plan-reducer-action";
import PlanFileData from "@/pages/takeoff/context/project-measure/models/plan-file-data.ts";

const fileReducer = (
    draft: PlanFileData,
    action: ProjectFilePlanReducerAction
): PlanFileData => {
    switch (action.type) {
        case 'set-dirty-flag':
            draft.setDirtyFlag(action.isDirty);
            break;
        case 'reset':
            return action.data;
        default:
            throw new Error('Unknown action type');
    }

    return draft;
}

export default fileReducer;